import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import { FadeBox, ContentFlex, componentHeights, Flex, Image } from 'ui/chandra'

import { useSurveyContext } from '../_store'

const FadeBoxContainer = styled(FadeBox)`
  &.fade-enter {
    position: absolute;
    opacity: 0;
  }
  &.fade-enter-done {
    position: relative;
    opacity: 1;
  }
`

const containerHeight = (format) => {
  return `calc(100vh - ${componentHeights.navbar[format]} - ${componentHeights.progressBar})`
}

const BoxContainer = styled('div')`
  display: inherit;
  height: ${containerHeight('desktop')};
  width: 50%;
  position: fixed;
  z-index: 10;

  @media all and (max-width: 1024px) {
    height: null;
  }

  @media all and (max-width: 640px) {
    height: auto;
    width: 100%;
    position: relative;
  }
`

const FlexContainer = styled(ContentFlex)`
  flex-direction: column;
  justify-content: center;
  padding: 60px 40px 170px 40px;

  @media all and (max-width: 1024px) {
    z-index: 20;
  }

  @media all and (max-width: 900px) {
    z-index: 1000; // sf chat z-index is 999
    padding: 20px 40px 170px 40px;
  }
`

const FlexWrapper = styled(Flex)`
  height: ${containerHeight('desktop')};
  width: 50%;
  margin-left: 50%;

  @media all and (max-width: 640px) {
    margin-left: 0;
    height: auto;
    width: 100%;
  }
`

const FlexBody = styled(Flex)`
  @media all and (max-width: 640px) {
    flex-direction: column;
  }
`

const LayoutContainer = ({ children }) => {
  const { state, transitionSpeed } = useSurveyContext()
  const step = state.pages[`step_${state.step}`] || {}

  const heroImageUrl =
    step.page &&
    step.page.heroImage.resolutions &&
    step.page.heroImage.resolutions.default

  //////////////////////////////////////////////////

  return useMemo(
    () => (
      <FlexBody>
        <BoxContainer>
          <TransitionGroup component={null}>
            <CSSTransition
              key={state.step}
              timeout={transitionSpeed}
              classNames='fade'
              appear
              mountOnEnter
              unmountOnExit
            >
              <FadeBoxContainer variant='primary' timeout={transitionSpeed}>
                <Image
                  src={heroImageUrl}
                  objectFit='cover'
                  width='100%'
                  height='100%'
                />
              </FadeBoxContainer>
            </CSSTransition>
          </TransitionGroup>
        </BoxContainer>

        {/* Survey content */}
        <FlexWrapper>
          <FlexContainer>{children}</FlexContainer>
        </FlexWrapper>
      </FlexBody>
    ),
    [state.step, children]
  )
}

LayoutContainer.propTypes = {
  children: PropTypes.node
}

export default LayoutContainer
